import React from 'react';
import './css/Footer.css';
import { useNavigate } from 'react-router-dom';
import logo from '../asset/Images/logo.png'
const Footer = () => {
  const navigate = useNavigate()
  return (
<footer className="footer-section">
  <div className="footer-container container">
    {/* Location Column */}
    <div className="footer-column">
      <h3 className="footer-heading">We Are Here</h3>
      <div className="footer-underline"></div>
      <p>
        <strong>Location:</strong>
        <br />
        1880 Braselton Hwy, Suite 122, Lawrenceville GA 30043, USA
      </p>
      <p>
        <strong>Email:</strong>
        <br />
        linsbistro@gmail.com
      </p>
      <p>
        <strong>Phone:</strong>
        <br />
        770-338-2887
      </p>
      <p>
        <strong>Fax:</strong>
        <br />
        770-338-8978
      </p>
    </div>

    {/* Center Column: Branding */}
    <div className="footer-column center-column">
      <img src={logo} alt="Lin's Bistro" className="footer-logo-img" />
      <p className="footer-subheading">Chinese • Thai • Authentic Cuisine</p>
      <p className="footer-description">
        Lin's Bistro brings you an exceptional journey of taste with the best of Chinese and Thai cuisine. 
        Enjoy our elegant ambiance, flavorful dishes, and top-notch service for an unforgettable dining experience.
      </p>
  
    </div>

    {/* Opening Time Column */}
    <div className="footer-column">
      <h3 className="footer-heading">Business Hours</h3>
      <div className="footer-underline"></div>
      <p>Monday: Closed</p>
      <p>Tuesday – Thursday: 11:00 am – 9:30 pm</p>
      <p>Friday: 11:00 am – 10:00 pm</p>
      <p>Saturday: 11:30 am – 10:00 pm</p>
      <p>Sunday: 11:30 am – 9:30 pm</p>
    </div>
  </div>
  <div className="footer-bottom">
    <p className="footer-copyright">
      © 2025 Lin's Bistro. All Rights Reserved.
    </p>

  </div>
</footer>
  )
};

export default Footer;
